import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import paid from "../assets/images/paid.jpg";
import c from "../assets/images/12c.jpg";
import jn from "../assets/images/jn.jpg";

function Modals() {
  const [isOpen, setIsOpen] = useState(false);
  const images = [jn, paid, c];
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    // Automatically open the popup when the component mounts
    setIsOpen(true);
  }, []);

  useEffect(() => {
    // Cycle through the images every 3 seconds
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 3000);
    return () => clearInterval(interval);
  }, [images.length]);

  // Function to close the modal
  const closeModal = () => {
    setIsOpen(false);
  };

  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          onClick={closeModal}
          className="fixed inset-0 bg-black bg-opacity-50 z-50 flex justify-center items-center"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
        >
          <motion.div
            onClick={(e) => e.stopPropagation()}
            className="relative bg-white p-6 rounded-lg shadow-lg max-w-2xl mx-auto"
            initial={{ scale: 0.8, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.8, opacity: 0 }}
            transition={{ duration: 0.3 }}
          >
            <button
              onClick={closeModal}
              className="absolute top-3 right-3 text-black bg-transparent rounded-full text-5xl p-2 leading-none"
            >
              &times;
            </button>
            <AnimatePresence mode="wait">
              <motion.img
                key={currentIndex}
                src={images[currentIndex]}
                alt={`Modal Slide ${currentIndex + 1}`}
                className="w-full h-auto rounded-t-lg"
                initial={{ x: "100%", opacity: 0 }}
                animate={{ x: 0, opacity: 1 }}
                exit={{ x: "-100%", opacity: 0 }}
                transition={{ duration: 0.5 }}
              />
            </AnimatePresence>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}

export default Modals;
